import { createTheme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// Mirrors the CSS tokens in index.module.css so MUI widgets match the rest of the portal
export const createMuiTheme = (mode: PaletteMode) => {
    const dark = mode === 'dark';

    return createTheme({
        palette: {
            mode,
            primary: dark
                ? { main: '#6fdc45', dark: '#8ae566', contrastText: '#142f3d' }
                : { main: '#1e4356', dark: '#142f3d', contrastText: '#ffffff' },
            secondary: { main: '#4fb82a', light: '#6fdc45', contrastText: '#142f3d' },
            error: { main: dark ? '#f8968c' : '#e35d50' },
            background: dark
                ? { default: '#0f1c23', paper: '#16262f' }
                : { default: '#f8f8f6', paper: '#ffffff' },
            text: dark
                ? { primary: '#dfe8ec', secondary: '#9cb0b9' }
                : { primary: '#1e2b33', secondary: '#5b6b74' },
            divider: dark ? '#263f4c' : '#e2e4e3',
        },
        shape: { borderRadius: 12 },
        typography: {
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            button: { textTransform: 'none', fontWeight: 500 },
        },
        components: {
            MuiButton: {
                defaultProps: { disableElevation: true },
                styleOverrides: { root: { borderRadius: 999, paddingInline: 20 } },
            },
            MuiDialog: {
                styleOverrides: { paper: { borderRadius: 20, backgroundImage: 'none' } },
            },
        },
    });
};
